const asc = (arr, propEval) =>
  [...arr].sort((a, b) => {
    const varA = propEval(a)
    const varB = propEval(b)

    if (varA < varB) return -1
    if (varA > varB) return 1
    return 0
  })

const desc = (arr, propEval) => asc(arr, propEval).reverse()

export default {
  asc,
  desc
}
